exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".list-item[data-v-41f24dcc]{box-sizing:border-box;overflow:hidden;position:relative;display:block;padding:10px 12px;margin:0;border:0;border-bottom:1px solid #eee;width:100%;background:#fff;text-align:left;font-size:12px;text-overflow:ellipsis;white-space:nowrap;outline:0}.label[data-v-41f24dcc]{position:absolute;top:50%;left:12px}.message[data-v-41f24dcc]{overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41f24dcc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ListItem.vue
// module id = 25
// module chunks = 0